module.exports = __webpack_public_path__ + "static/img/certificate-2.2ca18b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/certificate-2.png
// module id = /1mt
// module chunks = 1